import { render, staticRenderFns } from "./cUserMaintenanceReport.vue?vue&type=template&id=c2ea1896&scoped=true"
import script from "./cUserMaintenanceReport.vue?vue&type=script&lang=js"
export * from "./cUserMaintenanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea1896",
  null
  
)

export default component.exports